module.exports = __webpack_public_path__ + "img/9788937433238.fe94dfc1.jpg";